/**
 * Embla init for signage-category-list section (scoped per root).
 * Expects global EmblaCarousel from signage-category-list-embla.umd.js
 */
(function () {
  function destroy(root) {
    if (!root) return;
    if (typeof root._signageCategoryMqlCleanup === 'function') {
      root._signageCategoryMqlCleanup();
      root._signageCategoryMqlCleanup = null;
    }
    if (root._signageCategoryEmblaApi) {
      root._signageCategoryEmblaApi.destroy();
      root._signageCategoryEmblaApi = null;
    }
    root.removeAttribute('data-signage-category-initialized');
  }

  function init(root) {
    if (!root || root.getAttribute('data-signage-category-initialized') === 'true') {
      return;
    }

    const viewport = root.querySelector('[data-signage-embla-viewport]');
    if (!viewport || typeof window.EmblaCarousel !== 'function') {
      return;
    }

    const mql = window.matchMedia('(max-width: 750px)');

    function applyEmbla() {
      if (root._signageCategoryEmblaApi) {
        root._signageCategoryEmblaApi.destroy();
        root._signageCategoryEmblaApi = null;
      }

      if (mql.matches) {
        root._signageCategoryEmblaApi = window.EmblaCarousel(viewport, {
          align: 'start',
          containScroll: 'trimSnaps',
          dragFree: false,
        });
      }
    }

    function onMqlChange() {
      applyEmbla();
    }

    applyEmbla();
    mql.addEventListener('change', onMqlChange);

    root._signageCategoryMqlCleanup = function () {
      mql.removeEventListener('change', onMqlChange);
      if (root._signageCategoryEmblaApi) {
        root._signageCategoryEmblaApi.destroy();
        root._signageCategoryEmblaApi = null;
      }
    };

    root.setAttribute('data-signage-category-initialized', 'true');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-signage-category-list-root]').forEach(function (root) {
      init(root);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    target.querySelectorAll('[data-signage-category-list-root]').forEach(function (root) {
      destroy(root);
      init(root);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    target.querySelectorAll('[data-signage-category-list-root]').forEach(function (root) {
      destroy(root);
    });
  });
})();
